import React from 'react'
import { Loader } from 'src/components/map/google-map/loader'
import { FullScreenLoader } from 'src/layout/full-screen-loader'
import { MapOverlayProvider } from 'src/layout/modals/map-overlay'
import { AuthProvider, GoogleAuthProvider } from 'src/layout/providers/auth'
import { Root } from 'src/layout/providers/root'
import { AuthErrorBoundary } from 'src/components/errors/error-boundary'

type ProvidersProps = {
  children?: React.ReactNode
}

export const Providers = (props: ProvidersProps) => {
  return (
    <AuthErrorBoundary>
      <Loader>
        <Root>
          <React.Suspense fallback={<FullScreenLoader />}>
            <GoogleAuthProvider>
              <AuthProvider>
                <MapOverlayProvider>{props.children}</MapOverlayProvider>
              </AuthProvider>
            </GoogleAuthProvider>
          </React.Suspense>
        </Root>
      </Loader>
    </AuthErrorBoundary>
  )
}
